import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { getErrorMessageWithDefault } from 'helpers/errors';
import { useUploadPhotoMutation } from 'hooks/mutations/useUploadPhotoMutation';
import { useToast } from 'hooks/useToast';
import { setUserPhoto } from 'store/auth/authSlice';

interface Props {
  onClose: () => void;
}

export const useUploadPhotoPopupBL = ({ onClose }: Props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('app');

  const [errorMessage, setErrorMessage] = useState('');

  const { showSuccessToast, showErrorToast } = useToast();

  const uploadPhotoMutation = useUploadPhotoMutation({
    onSuccess: (data) => {
      showSuccessToast({
        title: t('uploadPhotoPopup.successToast'),
      });

      dispatch(setUserPhoto(data.big_url));
      onClose();
    },
    onError: (err) => {
      const msg: string = err.response?.data.photo?.[0] || '';

      setErrorMessage(msg);

      if (!msg) {
        showErrorToast({
          title: getErrorMessageWithDefault(err),
        });
      }
    },
  });

  const handleUploadPhoto = (file: File) => {
    uploadPhotoMutation.mutate({ photo: file });
  };

  return {
    isLoading: uploadPhotoMutation.isLoading,
    errorMessage,
    handleUploadPhoto,
  };
};
